import { render } from "./ComponentMenuUser.vue?vue&type=template&id=74b22e05&scoped=true"
import script from "./ComponentMenuUser.vue?vue&type=script&lang=js"
export * from "./ComponentMenuUser.vue?vue&type=script&lang=js"

import "./ComponentMenuUser.vue?vue&type=style&index=0&id=74b22e05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b22e05"]])

export default __exports__